import { Component, OnInit } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import { ApiService } from "src/app/services/api.service";
import { WalletHelperService } from "src/app/services/wallet-helper.service";

@Component({
  selector: "app-select-to-asset",
  templateUrl: "./select-to-asset.page.html",
  styleUrls: ["./select-to-asset.page.scss"],
})
export class SelectToAssetPage implements OnInit {
  selectedFromAsset: any;
  selectedPair: any;
  selectedAsset: any = null;
  selectedAssetWallets: Array<any> = [];
  toWallet: any;

  math: any = Math;

  pan_number: string;
  bank_account_number: string;
  bank_account_ifsc: string;

  constructor(
    private modalCtrl: ModalController,
    public navParams: NavParams,
    public api: ApiService,
    private walletHelper: WalletHelperService
  ) {
    this.selectedFromAsset = this.navParams.get("selectedFromAsset");
    this.toWallet = this.navParams.get("toWallet");
  }

  ngOnInit() {}

  closeModal() {
    this.modalCtrl.dismiss(null);
  }

  selectAsset(asset_id: number) {
    this.selectedAssetWallets = [];
    this.selectedPair = null;

    for (let i = 0; i < this.selectedFromAsset.pairs.length; i++) {
      if (this.selectedFromAsset.pairs[i].to_asset.asset_id == asset_id) {
        this.selectedAsset = this.selectedFromAsset.pairs[i].to_asset;
        this.selectedPair = this.selectedFromAsset.pairs[i];
      }
    }

    if (this.selectedAsset !== null) {
      for (let i = 0; i < this.api.wallets.length; i++) {
        if (
          this.api.wallets[i].blockchain_id == this.selectedAsset.blockchain_id
        ) {
          let wallet = this.api.wallets[i];
          this.selectedAssetWallets.push(wallet);
        }
      }
    }
  }

  resetSelection() {
    this.selectedAsset = null;
    this.selectedPair = null;
    this.selectedAssetWallets = [];
  }

  /**
   * select Wallet
   * @param wallet_id
   */
  selectWallet(wallet_id: number) {
    for (let i = 0; i < this.api.wallets.length; i++) {
      if (this.api.wallets[i].wallet_id == wallet_id) {
        let wallet = this.api.wallets[i];
        this.toWallet = wallet;
      }
    }
    let data = {
      fromAsset: this.selectedAsset,
      toWallet: this.toWallet,
      selectedPair: this.selectedPair,
    };

    this.modalCtrl.dismiss(data);
  }
}
